<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">{{ $t('meta.editCategory') }}</span>
    </v-card-title>
    <v-card-text>
      <v-form @submit.prevent="updateCategory" ref="form">
        <v-text-field v-model="category.genre_id" :label="$t('meta.genreId')" type="number" required></v-text-field>

        <v-text-field v-model="category.name" :label="$t('meta.name')" required></v-text-field>
        <v-text-field v-model="category.category_index" :label="$t('meta.index')" type="number" required></v-text-field>
        <v-text-field v-model="category.code" :label="$t('meta.code')" required></v-text-field>
        <v-text-field v-model="category.criteria_mapping" :label="$t('meta.criteriaMapping')" required></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="$emit('close')">{{ $t('meta.cancel') }}</v-btn>
      <v-btn color="blue darken-1" text @click="updateCategory">{{ $t('meta.save') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useI18n } from 'vue-i18n'

const { t: $t } = useI18n()

const props = defineProps(['category'])
const emit = defineEmits(['close', 'category-updated'])

const category = ref({})

onMounted(() => {
  category.value = {
    id: props.category.id,
    genre_id: props.category.genre_id, // Add genre_id field
    name: props.category.name,
    category_index: props.category.category_index,
    code: props.category.code,
    criteria_mapping: props.category.criteria_mapping
  }
})

async function updateCategory() {
  try {
    await axios.put(`/api/categories/${category.value.id}`, category.value)
    emit('category-updated')
    emit('close')
  } catch (error) {
    console.error('Error updating category:', error)
  }
}
</script>